<template>
    <div>

        <div class="main-header">
            <div class="container">
                <h2 class="main-header-text">
                    {{pageIndex == 1 ? "Change Security Confirmation" : "Change Security Phrase"}}</h2>
            </div>
        </div>
        <!-- eo main header -->
        <div class="main-section mgt-40">
            <div class="container">
                <div class="main-card">
                    <img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />                    
                        
                            <form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
                                <div v-if="pageIndex == 0">
                                    <div class="phrase-content security-phrase">
                                        <div class="content-inner csp">
                                            <div class="lock-img">
                                                <img width="20" src="/static/img/passphrase/lock.png">
                                            </div>
                                            <div class="sp-section">
                                                <h6>Security Phrase </h6>
                                                <p>Enter a phrase only you would know (30 character limit). This phrase
                                                    will appear on the login screen once the Username is entered.</p>
                                            </div>
                                            <div class="sp-section form-group">
                                                <label>Current Security Phrase</label>
                                                <h5 class="text-uppercase">{{PassPhrase}} </h5>
                                            </div>
                                            <div class="sp-section form-group">
                                                <label>Insert your phrase here :</label>
                                               
                                                <input autocomplete="off" id="passphrase" v-model="vModel.PassPhrase"
                                                v-only-uppercase
                                                    v-validate="'required|min:8|max:30'" data-vv-as='Phrase' v-drag-disable=''
                                                    :class="{'input': true, 'is-danger': errors.has('passphrase'),'form-control' : true ,'text-uppercase':true }"
                                                    type="text" placeholder="Insert Your Phrase" name="passphrase" />
                                                <div v-show="errors.has('passphrase')" class="help is-danger">
                                                    {{ errors.first('passphrase') }}</div>
                                            </div>

                                            <div class="button-wrap ">
                                                <button class="btn btn-next" type="submit">Confirm</button>
                                            </div>
                                        </div>
                                        <!--end Content inner-->
                                    </div>
                                    <!--end content-->
                                </div>
                                <div v-if="pageIndex == 1">
                                    <div class="phrase-content">
                                        <div class="content-inner">
                                            <div class="confirmation sp">
                                                <strong> Security Phrase Confirmation </strong>
                                                <p> Are you sure would like to set ? </p>
                                                <h2 class="text-uppercase"> {{vModel.PassPhrase}} </h2>
                                                <p> As your security Phrase ? </p>
                                            </div>



                                            <div class="button-wrap mar-t150">
                                                <button class="btn btn-not-me" type="cancel"
                                                    @click.prevent="onCancel">No</button>
                                                <button class="btn btn-yes" type="submit">Yes</button>
                                            </div>
                                        </div>
                                        <!--end Content inner-->
                                    </div>
                                    <!--end content-->
                                </div>
                                <div v-else-if="pageIndex == 2">
                                    <div class="phrase-content">
                                        <div class="content-inner">
                                            <div class="confirmation vn">
                                                <h5>Verify Your Phone Number </h5>
                                                <p> We've send a 6-digit verification code to </p>
                                                <h2> +{{otpModel.PhoneNumber}} </h2>
                                                <div class="input-number">
                                                    <input type="text" class="form-control" v-model="Key" v-mask="otpMask"
                                                        placeholder="1 - 2 - 3 - 4 - 5 - 6"
                                                        v-validate="'required|passphrase_otp'"
                                                        :class="{'input': true, 'is-danger': errors.has('Key'),'form-control' : true }"
                                                        name="Key">
                                                    <div v-show="errors.has('Key')" class="help is-danger">
                                                        {{ errors.first('Key') }}</div>
                                                </div>
                                            </div>
                                            <div class="code-time">
                                                {{Timer}}
                                            </div>

                                            <div class="button-wrap mar-t150" v-if="Timer == '00:00'">
                                                <span class="resend-code"> Didn't receive it ? <a href="#"
                                                        @click.prevent="onResendOtp()">Resend Code</a> </span>
                                            </div>
                                        </div>
                                        <!--end Content inner-->
                                    </div>
                                    <!--end content-->
                                </div>
                                <div v-else-if="pageIndex == 3">
                                    <div class="phrase-content">
                                        <div class="content-inner">
                                            <div class="confirmation sp">
                                                <strong> Security Phrase Updated </strong>
                                            </div>
                                            <!--end confirmation.sp-->
                                            <div class="udpated">
                                                <img src="/static/img/passphrase/updated.svg">
                                                <p>Your Security Phrase has<br> been Updated.<br>
                                                    The new Security Phrase will be <br> displayed during your next sign
                                                    in.
                                                </p>
                                            </div>

                                            <div class="button-wrap ">
                                                <button class="btn btn-next" type="submit">OK</button>
                                            </div>
                                        </div>
                                        <!--end Content inner-->
                                    </div>
                                    <!--end content-->
                                </div>
                            </form>



                        
                        <!-- eo col-8 -->

                        <!-- <div class="col-lg-4">
                            <UserDetailSection />
                        </div> -->
                  

                </div>
                <!-- eo main card -->

            </div>
            <!-- eo container -->
        </div>
        <!-- eo main section -->







    </div>
</template>

<script>
    import Base from "../../shared/Base.vue";
    import CommonService from "../../services/common";
    import ListService from "../../services/list";
    import Vue from "vue";
    import VueMask from "v-mask";
	Vue.use(VueMask);

    export default {
        name: "changepassphrase",
        //components: { UserDetailSection },
        extends: Base,
        beforeRouteEnter(to, from, next) {
            var promises = [];
            promises.push(ListService.getPassPhrase());
            Promise.all(promises).then(response => {
                next(p => {
                    if (response[0].body) {
                        p.PassPhrase = response[0].body.PassPhrase;
                    }
                });
            });

        },
        created() {
            debugger
            if (this.pageIndex == null) {
                this.pageIndex = 0;
            }
        },

        computed: {
           otpMask: function(){               
               return "#-#-#-#-#-#"
           } 
        },

        data() {
            return {
                pageIndex: 0,
                Timer: "",
                Key: null,
                PassPhrase: null,
                otpModel: {
                    OtpId: null,
                    PhoneNumber: null
                },
                vModel: {
                    PassPhrase: null,
                }
            };
        },
        
        watch: {
            Key: function (newValue, oldValue) {
               debugger;
                var self = this;               

                if (self.pageIndex == 2) {
                    if (self.isProcessing) return;
                    self.$validator.validate("Key", newValue).then(result => {
                        if (result) {
                            var url = "v2/account/passphrase/change/confirm";
                            var model = {
                                PassPhrase: self.vModel.PassPhrase,
                                Key: newValue.replace("-",'')
                            }

                            self.isProcessing = true;
                            self.$http.post(url, model).then(
                                response => {
                                    self.isProcessing = false;
                                    self.pageIndex = 3;
                                },
                                error => {
                                    self.isProcessing = false;
                                }
                            );
                        }

                    });
                }
            },
            pageIndex: function (newValue, oldValue) {
                debugger;
                var self = this;
                if (newValue == 2) {
                   self.createTimer();
                }
            }
        },

        methods: {
            onResendOtp: function () {
                var self = this;
                self.isProcessing = true;
                self.$http.post("mobile/otp/resend", self.otpModel).then(
                    response => {
                        self.$toastr("success", "OTP Resend Successfully");
                        self.isProcessing = false;
                        self.Timer = "";
                        self.createTimer();
                    },
                    error => {
                        self.isProcessing = false;
                    }
                );
            },

            createTimer(){
                var self = this;
                var time = 5*60;
                let interval = setInterval( () => {
                     var minutes = Math.floor( time / 60 );
                    if (minutes < 10) minutes = "0" + minutes;
                    var seconds = time % 60;
                    if (seconds < 10) seconds = "0" + seconds; 
                    self.Timer = minutes + ':' + seconds;
                    time--;  
                        if (time<= 0) {
                            clearInterval(interval);  
                            self.Timer = "00:00";                         
                        }                      
                    }, 1000);

                    
                   
            },

            onCancel: function () {
                if (this.pageIndex == 1) {
                    this.pageIndex = 0;
                }
            },            

            onSubmit() {
                var self = this;
                if (self.isProcessing) return;

                self.$validator.validateAll().then(result => {
                    if (result) {

                        if (self.pageIndex == 0) {
                            self.pageIndex = 1;
                        } else if (self.pageIndex == 1) {
                            var url = "v2/account/passphrase/change/init";
                            var model = self.vModel;

                            self.isProcessing = true;
                            self.$http.post(url, model).then(
                                response => {
                                    self.isProcessing = false;
                                    self.otpModel = response.body;
                                    self.pageIndex = 2;
                                    self.$toastr("success", "OTP send successfully.");

                                },
                                error => {
                                    self.isProcessing = false;
                                }
                            );


                        } else if (self.pageIndex == 2) {
                            var url = "v2/account/passphrase/change/confirm";
                            var model = {
                                PassPhrase: self.vModel.PassPhrase,
                                Key: self.Key
                            }

                            self.isProcessing = true;
                            self.$http.post(url, model).then(
                                response => {
                                    self.isProcessing = false;
                                    self.pageIndex = 3;
                                },
                                error => {
                                    self.isProcessing = false;
                                }
                            );

                        } else if (self.pageIndex == 3) {

                            if (window._sessionInterval != null) {
                                clearInterval(window._sessionInterval);
                            }

                            CommonService.destroyStorage();
                            self.$router.push("/account/login");

                        }
                    }
                });
            }
        }
    };
</script>
